import { RETRIES_COUNT } from "./constants/config.js";
function isHttpError(error) {
  return typeof error === "object" && error !== null && "status" in error && typeof error.status === "number";
}
const queryErrorHandler = (error, query) => {
  console.log("---------- Query error ----------");
  console.error("Query error:", error, "Query key:", query.queryKey);
  if (isHttpError(error) && error.status === 401) {
    console.warn(`${query.queryKey} - Unauthorized...`);
  }
  if (isHttpError(error) && error.status === 403) {
    console.warn(`${query.queryKey} - Forbidden...`);
  }
};
const globalErrorHandler = (error) => {
  console.error("Mutation error:", error);
};
const mutationErrorHandler = (error, variables) => {
  console.log("---------- Mutation error ----------");
  console.error("Mutation error:", error, "Variables:", variables);
  if (isHttpError(error) && error.status === 401) {
    console.warn("Mutation - Unauthorized...", {
      variables
    });
  }
  if (isHttpError(error) && error.status === 403) {
    console.warn("Mutation - Forbidden...", {
      variables
    });
  }
};
const defaultOptions = {
  handleAuthError: () => {
    console.warn("Global auth error handler not set");
  },
  // Stale time: how long data is considered fresh
  staleTime: 5 * 60 * 1e3,
  // 5 minutes
  // Cache time: how long data stays in cache after component unmounts
  gcTime: 10 * 60 * 1e3,
  // 10 minutes
  // Retry configuration
  retry: (failureCount, error) => {
    if (error instanceof Error) {
      return false;
    }
    return failureCount < RETRIES_COUNT;
  },
  // Retry delay with exponential backoff
  retryDelay: (attemptIndex) => Math.min(1e3 * 2 ** attemptIndex, 3e4),
  // Refetch on window focus
  refetchOnWindowFocus: false,
  // Refetch on reconnect
  refetchOnReconnect: true
};
export {
  defaultOptions,
  globalErrorHandler,
  mutationErrorHandler,
  queryErrorHandler
};
